export const filterBloodList = [
  { value: '', label: '전체', type: 'abo' },
  { value: 'A', label: 'A+', type: 'abo' },
  { value: 'A', label: 'A-', type: 'abo' },
  { value: 'B', label: 'B+', type: 'abo' },
  { value: 'B', label: 'B-', type: 'abo' },
  { value: 'O', label: 'O+', type: 'abo' },
  { value: 'O', label: 'O-', type: 'abo' },
  { value: 'AB', label: 'AB+', type: 'abo' },
  { value: 'AB', label: 'AB-', type: 'abo' },
];

export const filterBloodDonationTypeList = [
  { value: '', label: '전체', type: 'bloodProduct' },
  { value: 'WHOLE', label: '전혈 (RBC,F-RBC,WB)', type: 'bloodProduct' },
  {
    value: 'PLATELET',
    label: '혈소판헌혈 (A-PLT,A-PLT[M]',
    type: 'bloodProduct',
  },
  { value: 'LEUKOCYTE', label: '백혈구헌혈', type: 'bloodProduct' },
];

export const filterSortList = [
  { value: 'LAST_RENEWED_AT', label: '최신순', type: 'sortBy' },
  { value: 'BLOOD_DONATION', label: '헌혈인증순', type: 'sortBy' },
  { value: 'LIKE', label: '응원하기순', type: 'sortBy' },
];
